import { ShopResponse } from "api/dtos/responses/shop/ShopResponse";
import { RootReducer } from "stores/reducers";

export enum MenuItemType {
  Group,
  Item
}
export interface IMenuChildrents {
  id: string;
  title: string;
  type: MenuItemType;
  url: string;
  redirect?: boolean;
  icon?: any;
  disabled?: boolean;
  active?: boolean;
  enableFeatureHighlightUrl?: boolean;
  chip?: {
    nameReducer: keyof RootReducer;
  };
  onAfterClickMenu?: () => void;
}
export interface IMenuItems {
  id: string;
  title: string;
  type: MenuItemType;
  icon: any;
  url: string;
  label?: string;
  active?: boolean;
  children?: IMenuChildrents[];
  featureHighlight?: boolean;
  count?: number;
  defaultExpand?: boolean;
  onAfterClickMenu?: (shop: ShopResponse) => void;
  onRenderUrl?: () => string;
}
